
import IndexModelTable from "@/views/paginas/sigap/modelos/IndexModelTable.vue";
import CardRh from "@/components/cards/ManzaCard.vue";
import HoraAulaService from "@/service/v1/sigap/HoraAulaService";
import InstrutorService from "@/service/v1/sigap/InstrutorService";
import { Options } from "vue-class-component";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Cadastro from "./_Cadastro.vue";
import Editar from "./_Editar.vue";
import Multiselect from "@vueform/multiselect";

@Options({
    name: "HoraAulaIndex",
    components: { CardRh, KDataTable, Cadastro, Editar, Multiselect },
})
export default class HoraAulaIndex extends IndexModelTable {
    public modal_turma;
    public escolaridade_id: any = null;
    public escolaridades: any = null;
    public data_min: any = null; 
    public instrutorService = new InstrutorService();

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    get escolaridade_select() {
        if (this.escolaridades) {
            return this.escolaridades.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getEscolaridade() {
        this.processando = true;
        this.instrutorService.getEscolaridades()
            .then(response => {
                this.escolaridades = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public limparFiltros() { 
        this.escolaridade_id = null;
        this.data_min = null;
        this.refreshTable();
    }

    created() {
        this.service = new HoraAulaService();
        this.getEscolaridade();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    escolaridade: this.escolaridade_id,
                    data: this.data_min, 
                };
                return dados;
            }
        };

        this.modal_turma = "modal_npce_turma_";
        this.modal_atualizar = "modal_hora_aulas_update_";
        this.config.columns = [
            { data: "id", name: "id", class: "desktop" },
            { data: "escolaridade.nome", name: "escolaridade.nome", responsivePriority: 10003 },
            { data: "valorInterno", name: "valorInterno" },
            { data: "valorExterno", name: "valorExterno" },
            { data: "inicio", name: "inicio" },
            { data: "fim", name: "fim" },
            { data: "docPublicacao", name: "docPublicacao" },
        ];
        this.config.columnDefs = [
            {
                targets: 4,
                render: function (row) {
                    return SiteUtils.formatData(row);
                }
            },
            {
                targets: 5,
                render: function (row) {
                    return SiteUtils.formatData(row);
                }
            }
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 7,
                    render: (row, type, val) => {
                        let texto = "";
                        let buttom = "";
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-success btn-sm" btn-editar ' + buttom + ' data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_atualizar + '"><i class="fa fa-edit"></i></button>';
                        texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-excluir ' + buttom + '><i class="fa fa-trash"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $("[btn-editar]").click((btn) => {
            this.dados = null;
            setTimeout(() => {
                this.dados = $(btn.currentTarget).data();
            }, 10);
        });
        $("[btn-excluir]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            this.excluirModelo(id);
        });
    }
}
